import React from 'react';
import { FiMoreVertical } from 'react-icons/fi';
import { DropdownMenu, DropdownMenuContent, DropdownMenuItem, DropdownMenuTrigger } from '@/components/ui/dropdown-menu';
import usePermission from '@/hooks/usePermission';
import { LiveClassCard } from '../PlayfulShared/LiveClassCard';

export function LiveClassCardTeacher({ liveClass, status, onClick, onEdit, onDelete }) {
  // Mesmas permissões do menu (⋯) do card no Default (LiveClassCard.jsx).
  const canEdit = usePermission('Editar aulas ao vivo', 'Aulas ao vivo');
  const canDelete = usePermission('Excluir aulas ao vivo', 'Aulas ao vivo');
  const showActionsMenu = canEdit || canDelete;

  return (
    <LiveClassCard
      liveClass={liveClass}
      status={status}
      onClick={onClick}
      testId="live-class-card-teacher"
      actions={
        showActionsMenu && (
          <DropdownMenu>
            <DropdownMenuTrigger asChild>
              <button
                type="button"
                aria-label="Mais opções"
                className="absolute right-2 top-2 flex h-6 w-6 items-center justify-center rounded-full text-neutral-dark hover:bg-black/5"
              >
                <FiMoreVertical className="h-4 w-4" />
              </button>
            </DropdownMenuTrigger>

            <DropdownMenuContent align="end">
              {canEdit && <DropdownMenuItem onSelect={() => onEdit(liveClass)}>Editar</DropdownMenuItem>}
              {canDelete && <DropdownMenuItem onSelect={() => onDelete(liveClass)}>Excluir</DropdownMenuItem>}
            </DropdownMenuContent>
          </DropdownMenu>
        )
      }
    />
  );
}
